(function () {
  document.addEventListener('DOMContentLoaded', function () {
    let selectProductBtn = document.querySelector('.select-product__button'),
      selectProductBtnImage = selectProductBtn.querySelector('.product-image'),
      selectProductBtnTitle = selectProductBtn.querySelector('.btn__text'),
      popupContainer = selectProductBtn.querySelector('.popup__content--container'),
      searchProductCardTemplate = document.querySelector('#search__product--card'),
      popupContentData = JSON.parse(document.querySelector('[data-popup-content]').textContent),
      productListContainer = document.querySelector(`.products__list--wrapper[data-products-list]`),
      searchProductCard = searchProductCardTemplate.content,
      collectionBubbles = document.querySelectorAll('.filters__wrapper .collection-bubble'),
      searchInput = document.querySelector('.product__popup--search'),
      recommendations = document.querySelector('#guide-page-product__recommendation-row'),
      searchPopupClose = document.querySelector('.popup__close--search'),
      selectedProduct = window.location.href?.split('product=')?.[1],
      baseUrl = `${window.location.protocol}//${window.location.hostname}${window.location.pathname}`,
      allProductsFromCollections = [],
      screenWidth = window.innerWidth;

    if (
      selectProductBtn &&
      popupContainer &&
      searchProductCard &&
      popupContentData &&
      collectionBubbles &&
      searchInput &&
      productListContainer
    ) {
      // get default products
      Object.keys(popupContentData.collections).forEach(function (collectionHandle) {
        var products = popupContentData.collections[collectionHandle].products;
        allProductsFromCollections = allProductsFromCollections.concat(products);
      });
      //  handle popup open
      selectProductBtn.querySelector('.btn__text').addEventListener('click', () => {
        let selectedBubble = document.querySelector('.filters__wrapper .collection-bubble.is-active');
        selectProductBtn.toggleAttribute('open');
        if (selectedBubble) {
          let products = popupContentData.collections[selectedBubble.dataset.collectionHandle].products;
          createProductsList(products, searchProductCard, productListContainer, true);
        } else {
          createProductsList(allProductsFromCollections, searchProductCard, productListContainer);
        }
        if (screenWidth <= 749) document.querySelector('html').classList.add('overflow-hidden');
      });
      // handle popup collection filters
      collectionBubbles.forEach((bubble) => {
        bubble.addEventListener('click', () => {
          if (bubble.classList.contains('is-active')) {
            bubble.classList.remove('is-active');
            bubble.classList.remove(`color-${bubble.dataset.activeScheme}`);
            createProductsList(allProductsFromCollections, searchProductCard, productListContainer);
          } else {
            collectionBubbles.forEach((item) => {
              item.classList.remove('is-active');
              item.classList.remove(`color-${item.dataset.activeScheme}`);
            });
            bubble.classList.add('is-active');
            bubble.classList.add(`color-${bubble.dataset.activeScheme}`);
            let products = popupContentData.collections[bubble.dataset.collectionHandle].products;
            createProductsList(products, searchProductCard, productListContainer, true);
          }
        });
      });
      // handle search field
      searchInput.addEventListener('input', async (e) => {
        collectionBubbles.forEach((item) => {
          item.classList.remove('is-active');
          item.classList.remove(`color-${item.dataset.activeScheme}`);
        });
        if (e.target.value == '') {
          createProductsList(allProductsFromCollections, searchProductCard, productListContainer);
          return;
        }
        let products = await searchProducts(e.target.value);
        createProductsList(products, searchProductCard, productListContainer);
      });
      // handle product select
      productListContainer.addEventListener('click', (e) => {
        if (e.target.classList.contains('search__product--card')) {
          let handle = e.target.getAttribute('data-product-handle');
          window.location = `${baseUrl}?product=${handle}`;
        }
      });
    }
    // handle selected product
    if (selectedProduct && selectProductBtnImage && selectProductBtnTitle && recommendations) {
      let currentSelectedProduct = getProductByHandle(selectedProduct, popupContentData);
      selectProductBtn.classList.add('is-selected');
      if (currentSelectedProduct) {
        selectProductBtnImage.classList.remove('hidden');
        selectProductBtnImage.src = currentSelectedProduct.featuredImage;
        selectProductBtnTitle.innerText = currentSelectedProduct.title;
        // handle updating recommendations
        if (currentSelectedProduct.recommendation) recommendations.innerHTML = currentSelectedProduct.recommendation;
        // handle intake times
        handleIntakeTimes(currentSelectedProduct);
        // update guide page text
        let guidePageText = document.querySelector('.guide-page__info-text');
        if (guidePageText && guidePageText.dataset.text) {
          guidePageText.parentElement.classList.remove('hidden');
          guidePageText.innerHTML = guidePageText.dataset.text.replace(
            '[Produktname]',
            currentSelectedProduct.shortTitle
          );
        }
        // handle combine products recommendations
        handleCombineProductsRecommendations(currentSelectedProduct);
      }
    }
    // handle close search popup
    if (searchPopupClose && selectProductBtn) {
      searchPopupClose.addEventListener('click', () => {
        selectProductBtn.removeAttribute('open');
      });
    }
  });
  function createProductsList(list, template, container, collection = false) {
    if (list.length <= 0) return;
    let elements = [];
    container.innerHTML = '';
    list.forEach((item) => {
      if (item.handle.toLowerCase().includes('paket')) return;
      let newProduct = document.importNode(template, true);
      newProduct.querySelector('.search__product--card').setAttribute('data-product-handle', item.handle);
      newProduct.querySelector('.title').textContent = item.title;
      if (item.image) {
        let newImageUrl = item.image.replace(/(\.(png|jpg|jpeg|gif|webp))(\?.*)?$/, '_200x$1$3');
        newProduct.querySelector('img').src = newImageUrl;
      } else newProduct.querySelector('img').src = item.featuredImage;
      elements.push(newProduct);
    });
    container.append(...elements);
  }
  async function searchProducts(searchTerm) {
    if (searchTerm.trim() == '') return [];
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(
          `/search/suggest.json?q=${encodeURIComponent(searchTerm)}&resources[type]=product`
        );
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        if (!data) resolve([]);
        resolve(data.resources.results.products || []);
      } catch (error) {
        reject(error);
      }
    });
  }
  function getProductByHandle(handle, data) {
    return data.products.find((product) => product.handle === handle);
  }
  function findPositiveProductByHandle(handle, product) {
    return product.positives.find((item) => item.handle === handle);
  }
  function handleIntakeTimes(product) {
    if (!product.intake) return;
    const exclude = ['positive', 'negative'];
    const intake = product.intake;

    const intakeSettings = {
      morning: intake.includes('Morgens'),
      midday: intake.includes('Mittags'),
      evening: intake.includes('Abends'),
    };

    Object.keys(intakeSettings).forEach(function (key) {
      if (!exclude.includes(key)) {
        if (intakeSettings[key]) {
          document.querySelector(`.guide-page__product-intake-row-${key}`).classList.remove('hidden');
          document.querySelector(`#guide-page__product-intake-positive-${key}`).classList.remove('hidden');
        } else {
          document.querySelector(`.guide-page__product-intake-row-${key}`).classList.add('hidden');
        }
      }
    });
  }
  function handleCombineProductsRecommendations(product) {
    if (!product) return;

    let productTemplate = document.querySelector('#recommendation-product__card'),
      positiveContainer = document.querySelector('.positive__wrapper .products__wrapper[data-products]'),
      negativeContainer = document.querySelector('.negative__wrapper .products__wrapper[data-products]'),
      positiveHeading = document.querySelector('.positive__heading span[data-selected-heading]'),
      extraInfoSection = document.querySelector('.guide-page__info-negative'),
      productGuideContainer = document.querySelector('.product__guide--container'),
      sectionWrapper = document.querySelector('.combine__wrapper'),
      productCard = productTemplate.content,
      screenWidth = window.innerWidth;

    if (productCard && positiveContainer && negativeContainer && positiveHeading && sectionWrapper) {
      // Clear existing products
      positiveContainer.innerHTML = '';
      negativeContainer.innerHTML = '';

      let positiveNodes = [];
      let negativeNodes = [];

      // Loop through positives
      if (product.positives && product.positives.length > 0) {
        product.positives.forEach((positiveProduct) => {
          let clone = document.importNode(productCard, true);
          clone.querySelector('.popup__btn').setAttribute('data-product-handle', positiveProduct.handle);
          clone.querySelector('.atc__btn').setAttribute('data-product-handle', positiveProduct.handle);
          clone.querySelector('.atc__btn').setAttribute('data-variant-id', positiveProduct.variants[0].id);
          clone.querySelector('.atc__btn').setAttribute('data-selling-plan-id', positiveProduct.sellingPlanId);
          clone.querySelector('img').src = positiveProduct.featuredImage;
          clone.querySelector('.product__title').textContent = positiveProduct.shortTitle;
          clone.querySelector('.product__desc').innerHTML = positiveProduct.longTitle;

          positiveNodes.push(clone);
        });

        positiveNodes.forEach((node) => positiveContainer.appendChild(node));
        positiveContainer.parentElement.classList.remove('hidden');
        if (product.positives.length <= 5) positiveContainer.parentElement.classList.add('hide-btns');
        if (product.positives.length <= 2 && screenWidth <= 749) positiveContainer.classList.add('hide-dots');
        if (product.positives.length <= 5 && screenWidth > 989) positiveContainer.classList.add('hide-dots');
        // Initialize Flickity for the positive container with custom buttons
        const positiveFlickity = new Flickity(positiveContainer, {
          cellAlign: screenWidth <= 749 ? 'left' : 'center',
          contain: screenWidth <= 749 ? false : true,
          pageDots: true,
          groupCells: screenWidth <= 749 ? false : true,
          wrapAround: screenWidth <= 749 ? true : false,
          prevNextButtons: false, // Disable default buttons
          freeScroll: false,
          // Smooth scrolling parameters
          friction: 0.3, // Lower friction for smoother sliding (default: 0.75)
          selectedAttraction: 0.08, // Lower attraction for smoother transitions (default: 0.025)
          imagesLoaded: true, // Recalculate layout after images load
          draggable: '>1', // Only enable drag if more than one cell
          dragThreshold: 3, // Lower this value to make dragging more responsive
        });

        // Enhanced scroll prevention for positive container
        let positiveIsDragging = false;

        positiveContainer.addEventListener(
          'pointerdown',
          () => {
            positiveIsDragging = true;
          },
          { passive: false }
        );

        positiveContainer.addEventListener(
          'pointermove',
          (e) => {
            if (positiveIsDragging && positiveFlickity.isDragging) {
              e.preventDefault();
            }
          },
          { passive: false }
        );

        document.addEventListener('pointerup', () => {
          positiveIsDragging = false;
        });

        positiveContainer.addEventListener(
          'touchstart',
          () => {
            positiveIsDragging = true;
          },
          { passive: false }
        );

        positiveContainer.addEventListener(
          'touchmove',
          (e) => {
            if (positiveIsDragging && positiveFlickity.isDragging) {
              e.preventDefault();
            }
          },
          { passive: false }
        );

        document.addEventListener('touchend', () => {
          positiveIsDragging = false;
        });

        // Add custom prev/next buttons
        const positivePrevButton = document.createElement('button');
        positivePrevButton.classList.add('flickity-custom-prev-btn');
        positivePrevButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none" style="transform: rotate(180deg);">
          <path d="M5.18677 1.47333L13.4801 8.49999L5.18677 15.5267" stroke="#454443" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`;
        positiveContainer.parentElement.appendChild(positivePrevButton);

        const positiveNextButton = document.createElement('button');
        positiveNextButton.classList.add('flickity-custom-next-btn');
        positiveNextButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
          <path d="M5.18677 1.47333L13.4801 8.49999L5.18677 15.5267" stroke="#454443" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`;
        positiveContainer.parentElement.appendChild(positiveNextButton);

        // Add event listeners
        positivePrevButton.addEventListener('click', () => {
          positiveFlickity.previous();
        });
        positiveNextButton.addEventListener('click', () => {
          positiveFlickity.next();
        });
      } else {
        positiveContainer.parentElement.classList.add('hidden');
      }

      // Loop through negatives
      if (product.negatives && product.negatives.length > 0) {
        product.negatives.forEach((negativeProduct) => {
          let clone = document.importNode(productCard, true);
          clone.querySelector('.popup__btn').setAttribute('data-product-handle', negativeProduct.handle);
          clone.querySelector('.atc__btn').setAttribute('data-product-handle', negativeProduct.handle);
          clone.querySelector('.atc__btn').setAttribute('data-variant-id', negativeProduct.variants[0].id);
          clone.querySelector('img').src = negativeProduct.featuredImage;
          clone.querySelector('.product__title').textContent = negativeProduct.shortTitle;
          clone.querySelector('.product__desc').innerHTML = negativeProduct.longTitle;

          negativeNodes.push(clone);
        });

        negativeNodes.forEach((node) => negativeContainer.appendChild(node));
        negativeContainer.parentElement.classList.remove('hidden');
        if (product.negatives.length <= 5) negativeContainer.parentElement.classList.add('hide-btns');
        if (product.negatives.length <= 2 && screenWidth <= 749) negativeContainer.classList.add('hide-dots');
        if (product.negatives.length <= 5 && screenWidth > 989) negativeContainer.classList.add('hide-dots');

        // Initialize Flickity for the negative container with custom buttons
        const negativeFlickity = new Flickity(negativeContainer, {
          cellAlign: screenWidth <= 749 ? 'left' : 'center',
          contain: screenWidth <= 749 ? false : true,
          pageDots: true,
          groupCells: screenWidth <= 749 ? false : true,
          wrapAround: screenWidth <= 749 ? true : false,
          prevNextButtons: false, // Disable default buttons
          freeScroll: false,
          // Smooth scrolling parameters
          friction: 0.3, // Lower friction for smoother sliding (default: 0.75)
          selectedAttraction: 0.08, // Lower attraction for smoother transitions (default: 0.025)
          imagesLoaded: true, // Recalculate layout after images load
          draggable: '>1', // Only enable drag if more than one cell
          dragThreshold: 3, // Lower this value to make dragging more responsive
        });

        // Enhanced scroll prevention for negative container
        let negativeIsDragging = false;

        negativeContainer.addEventListener(
          'pointerdown',
          () => {
            negativeIsDragging = true;
          },
          { passive: false }
        );

        negativeContainer.addEventListener(
          'pointermove',
          (e) => {
            if (negativeIsDragging && negativeFlickity.isDragging) {
              e.preventDefault();
            }
          },
          { passive: false }
        );

        document.addEventListener('pointerup', () => {
          negativeIsDragging = false;
        });

        negativeContainer.addEventListener(
          'touchstart',
          () => {
            negativeIsDragging = true;
          },
          { passive: false }
        );

        negativeContainer.addEventListener(
          'touchmove',
          (e) => {
            if (negativeIsDragging && negativeFlickity.isDragging) {
              e.preventDefault();
            }
          },
          { passive: false }
        );

        document.addEventListener('touchend', () => {
          negativeIsDragging = false;
        });

        // Add custom prev/next buttons
        const negativePrevButton = document.createElement('button');
        negativePrevButton.classList.add('flickity-custom-prev-btn');
        negativePrevButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none" style="transform: rotate(180deg);">
          <path d="M5.18677 1.47333L13.4801 8.49999L5.18677 15.5267" stroke="#454443" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`;
        negativeContainer.parentElement.appendChild(negativePrevButton);

        const negativeNextButton = document.createElement('button');
        negativeNextButton.classList.add('flickity-custom-next-btn');
        negativeNextButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
          <path d="M5.18677 1.47333L13.4801 8.49999L5.18677 15.5267" stroke="#454443" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`;
        negativeContainer.parentElement.appendChild(negativeNextButton);

        // Add event listeners
        negativePrevButton.addEventListener('click', () => {
          negativeFlickity.previous();
        });
        negativeNextButton.addEventListener('click', () => {
          negativeFlickity.next();
        });
        if (productGuideContainer) productGuideContainer.classList.remove('product__guide--container--spacing');
      } else {
        negativeContainer.parentElement.classList.add('hidden');
        if (extraInfoSection) extraInfoSection.classList.add('hidden');
        if (productGuideContainer) productGuideContainer.classList.add('product__guide--container--spacing');
      }

      // Update heading with the selected product title
      positiveHeading.innerHTML = positiveHeading
        .getAttribute('data-selected-heading')
        .replace('[PRODUKTNAME]', product.shortTitle);
      // handle container listener
      sectionWrapper.addEventListener('click', (event) => {
        // handle add to cart
        if (event.target && event.target.classList.contains('atc__btn')) {
          if (event.target.dataset.variantId) {
            const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            if (window.quickAddToCart)
              window.quickAddToCart.addToCart(parseInt(event.target.dataset.variantId), 1, cart);
          }
        }
        // handle popup popup open
        if (event.target && event.target.classList.contains('popup__btn')) {
          const productHandle = event.target.getAttribute('data-product-handle');
          const productData = findPositiveProductByHandle(productHandle, product);

          if (productData) {
            openPopup(productData);
          }
        }
      });
    }
  }
  function openPopup(product) {
    const popupOverlay = document.querySelector('.popup__overlay.positive__products--popup');
    popupOverlay.querySelector('.product__image').src = product.popupImage;
    popupOverlay.querySelector('.title').textContent = product.shortTitle;
    popupOverlay.querySelector('.sub_title').textContent = product.longTitle;
    popupOverlay.querySelector('.desc').innerHTML = product.shortDescription;
    popupOverlay.querySelector('.original__price').textContent = product.price;
    popupOverlay.querySelector('.compare__price').textContent = product.compareAtPrice;
    popupOverlay.querySelector('.unit__price .unit__price--text').textContent = `(${product.unit_price})`;
    popupOverlay.querySelector('.popup__show__product').href = product.url;
    popupOverlay.querySelector('.popup__atc__btn').setAttribute('data-variant-id', product.variants[0].id);
    popupOverlay.querySelector('.popup__atc__btn').setAttribute('data-selling-plan-id', product.sellingPlanId);
    popupOverlay.querySelector('.rating__wrapper').innerHTML = product.reviewsBadge || '';
    popupOverlay.querySelector('.ac-price-tooltip .text').innerHTML = product.pricePerDay;
    if (product.price_without_currency >= product.compare_price_without_currency) {
      popupOverlay.querySelector('.compare__price').classList.add('hidden');
    }
    if (product.pricePerDay.trim() == '') {
      popupOverlay.querySelector('.ac-price-tooltip').classList.add('hidden');
    }
    const bulletWrapper = popupOverlay.querySelector('.bullet__points--wrapper');
    const bulletTemplate = document.querySelector('#positive-product-bullet');
    bulletWrapper.innerHTML = '';
    const usps = Array.isArray(product.usps) ? product.usps : [];
    usps.forEach((usp) => {
      if (!usp) return;
      const clone = bulletTemplate.content.cloneNode(true);
      clone.querySelector('.text').textContent = usp;
      bulletWrapper.appendChild(clone);
    });
    // handle close
    popupOverlay.addEventListener('click', (event) => {
      if (event.target.classList.contains('popup__overlay') || event.target.classList.contains('popup__close')) {
        event.target.closest('.popup__overlay').style.display = 'none';
        document.querySelector('html').classList.remove('overflow-hidden');
      }
      if (event.target.classList.contains('popup__atc__btn')) {
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (window.quickAddToCart) window.quickAddToCart.addToCart(parseInt(event.target.dataset.variantId), 1, cart);
        event.target.closest('.popup__overlay').style.display = 'none';
        document.querySelector('html').classList.remove('overflow-hidden');
      }
    });
    // Show the popup
    document.querySelector('html').classList.add('overflow-hidden');
    popupOverlay.style.display = 'block';
  }
})();
